interface IModalWindow {
  children: any;
  state: boolean;
  setState: any;
}
export default function ModalWidnow({
  children,
  state,
  setState,
}: IModalWindow) {
  if (!state) return null;
  return (
    <div
      className="fixed top-0 right-0 left-0 bottom-0 h-full bg-black/50"
      onClick={() => setState(false)}
    >
      <div
        className="w-50 h-50 absolute top-1/2 left-1/2 p-[25px] bg-white justify-center items-center text-center rounded-lg transform -translate-x-1/2 -translate-y-1/2"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
